import { Component, EventEmitter, Input, Output } from '@angular/core';
import { forkJoin } from 'rxjs';
import { AlertMessage } from 'src/app/template/models/alert-message.model';
import { EnrollmentNew } from 'src/app/modules/enrollments/models/enrollment-new.model';
import { Approbation } from 'src/app/modules/approbations/models/approbation.model';
import { ApprobationService } from 'src/app/modules/approbations/services/approbation.service';

@Component({
    selector: 'app-enrollment-edit-step-approbations',
    templateUrl: './enrollment-edit-step-approbations.component.html',
    styleUrls: ['./enrollment-edit-step-approbations.component.scss']
})
export class EnrollmentEditStepApprobationsComponent {

    @Input() enrollment: EnrollmentNew;

    @Output() enrollmentChange = new EventEmitter<EnrollmentNew>();
    @Output() isCompleteStep   = new EventEmitter<boolean>();

    public labels: any = {

        approbationsLabel   : 'Marque las autorizaciones correspondientes',
        loadingErrorMessage : 'Se ha producido un error al cargar la página.'

    }

    public isLoadingData : boolean = true;
    public loadingMessage: AlertMessage = new AlertMessage();

    public approbations: Approbation[];
    public selectedApprobations: Approbation[];

    constructor(private approbationService: ApprobationService) { }

    ngOnInit (): void {

        this.initData();
        this.onEnrollmentChange();

    }

    private initData() {

        forkJoin({

            approbationsRequest: this.approbationService.getByEdition(this.enrollment.edition.editionId),

        }).subscribe({

            next: (requests: any) => {

                this.approbations = requests.approbationsRequest;

            },

            error: (error: any) => {

                this.loadingMessage.showDangerAlert(this.labels.loadingErrorMessage);

            }

        }).add(() => {
            this.isLoadingData = false;
        });

    }

    public onApprobationsChange() {

        this.onEnrollmentChange();

    }

    public isFormValid() {

        return true;

    }

    public onEnrollmentChange() {

        this.isCompleteStep.emit(this.isFormValid());
        this.enrollmentChange.emit(this.enrollment);

    }

}
